import { useGetSpecialRequestQuery } from 'lib/apollo/hooks'
import { TSpecialRequestInfoModalProps } from './SpecialRequestInfoModal.types'
import { useIsMobile } from 'lib/utils/mediaQueries'
import { useEffect } from 'react'
import { useApolloClients } from 'lib/apollo/apolloProvider'

export const useSpecialRequestInfoModalLogic = (
  props: TSpecialRequestInfoModalProps
) => {
  const { surgeryId, onFinishLoading } = props
  const { iservicesClient } = useApolloClients()

  const isMobile = useIsMobile()

  const { data: specialRequestsData, loading: isLoadingSpecialRequest } =
    useGetSpecialRequestQuery({ surgeryId, client: iservicesClient })

  const specialRequests = specialRequestsData?.getSpecialRequests.data || []

  useEffect(() => {
    if (!isLoadingSpecialRequest) {
      onFinishLoading(false)
    }
  }, [isLoadingSpecialRequest, onFinishLoading])

  return {
    isMobile,
    specialRequests,
    isLoadingSpecialRequest,
  }
}
